<template>
  <div>
    <!-- Loading State -->
    <div v-if="loading" class="flex justify-center py-8" role="status">
      <svg class="animate-spin h-6 w-6" style="color: var(--text-muted);" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
      <span class="sr-only">Loading...</span>
    </div>

    <!-- Content -->
    <div v-else class="space-y-4">
      <!-- Google Account -->
      <AccountConnectionItem
        icon="google"
        title="Google account"
        :connected-count="googleAccountsCount"
        connect-url="/google/auth/google_oauth2/initiate"
        @view="handleViewGoogleAccounts" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getGoogleAccountsCount } from '~/javascript/api/google_accounts'
import useSlidePanel from '~/javascript/composables/use_slide_panel'
import GoogleAccountsList from './google_accounts_list.vue'
import AccountConnectionItem from './account_connection_item.vue'

// Composables
const slidePanel = useSlidePanel()

// State
const loading = ref(true)
const googleAccountsCount = ref(0)

// Methods
const fetchAccountCounts = async() => {
  try {
    const response = await getGoogleAccountsCount()
    googleAccountsCount.value = response.data.count
  } catch (error) {
    console.error('Failed to fetch account counts:', error)
  } finally {
    loading.value = false
  }
}

// Event handlers
const handleViewGoogleAccounts = () => {
  slidePanel.open({
    component: GoogleAccountsList,
    props: {},
    position: 'right'
  })
}

// Lifecycle
onMounted(() => {
  fetchAccountCounts()
})
</script>
